import { Route, Routes } from "react-router-dom";

import { Layout } from "@/components/layout/Layout";
import About from "@/pages/About";
import Admin from "@/pages/Admin";
import Docs from "@/pages/Docs";
import Home from "@/pages/Home";
import Landing from "@/pages/Landing";
import Samples from "@/pages/Samples";

export default function App() {
  return (
    <Routes>
      {/* Landing page has its own layout (no shared nav) */}
      <Route index element={<Landing />} />

      {/* App routes use the shared Layout with nav */}
      <Route element={<Layout />}>
        <Route path="/demo" element={<Home />} />
        <Route path="/samples" element={<Samples />} />
        <Route path="/docs" element={<Docs />} />
        <Route path="/about" element={<About />} />
        <Route path="/admin" element={<Admin />} />
      </Route>
    </Routes>
  );
}
